import { render } from "./XCalendarComponent.vue?vue&type=template&id=054edd80&scoped=true"
import script from "./XCalendarComponent.vue?vue&type=script&lang=js"
export * from "./XCalendarComponent.vue?vue&type=script&lang=js"

import "./XCalendarComponent.vue?vue&type=style&index=0&id=054edd80&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054edd80"]])

export default __exports__